import { get, HttpResponse } from '@/api/Api';
import { api_url } from '@/api/thg/api';
import { TokenType } from '@/enums/TokenType';
import { THGCarPayoffAmount } from '@/interfaces/thg/THGlobals';

/**
 * Retrieve the current THG payoff amounts
 *
 * @return payoffs response
 */
export async function getPayoffs(): Promise<HttpResponse<THGCarPayoffAmount[]>> {
    return await get<THGCarPayoffAmount[]>(`${api_url()}/globals/payoffs`, TokenType.THG_API_KEY);
}
